export default "__VITE_ASSET__Bc0Td5di__"